import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import logo from "../../assets/INVESTYCOONS LOGO.png"
import { ts } from '../utils/metaData';

const AdminLogin = () => {
    const navigate = useNavigate();

    useEffect(() => {
        sessionStorage.clear();
    }, []);

    const [data, setData] = useState({
        phone: "",
        password: "",
    });

    const onChangeHandler = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
    };

    const onClickSubmit = async () => {
        try {
            if (!data.phone || !data.password) {
                toast.error('All Fields Are Required!');
                return;
            }
            const headers = {
                'Content-Type': 'application/json',
                pid: 'INVST',
            };

            const body = JSON.stringify({
                meta: {
                    pid: 'INVST',
                    appName: 'dashboard',
                    ts: ts(),
                    clientIp: 'N/A',
                    reqAction: 'allLeads',
                    location: 'N/A',
                },
                pay: {
                    phone: data.phone,
                    password: data.password,
                },
            });

            const response = await fetch(`${process.env.REACT_APP_BASEURL}/admin/allLeads`, {
                method: "POST",
                body: body,
                headers: headers,
            })
            const result = await response.json()

            if (result.statusCode === '000') {
                sessionStorage.setItem('phone', data.phone);
                navigate('/dashboard', {
                    replace: true,
                    state: { data: result.data }
                });
                toast.success('Login Successful!')
            } else {
                toast.error(result.message || 'Invalid Credentials');
            }
        } catch (error) {
            console.log(error);
            toast.error('Something Went Wrong!');
        }
    }

    return (
        <div className="flex h-screen">
            <div className="hidden lg:flex items-center justify-center flex-1 bg-white text-black">
                <img src={logo} alt="logo" />
            </div>
            <div className="w-full bg-gray-100 lg:w-1/2 flex items-center justify-center">
                <div className="max-w-md w-full p-6">

                    <h1 className="text-3xl font-bold mb-6 text-green-600 text-center">LOGIN</h1>
                    <div className="space-y-4">
                        <div>
                            <label htmlFor="phone" className="block text-sm font-medium text-gray-700">Phone</label>
                            <input
                                type="text"
                                placeholder='Phone'
                                id="phone"
                                name="phone"
                                value={data.phone}
                                onChange={onChangeHandler}
                                className="mt-1 p-2 w-full border rounded-md focus:border-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 transition-colors duration-300"
                            />
                        </div>
                        <div>
                            <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password</label>
                            <input
                                type="password"
                                placeholder='Password'
                                id="password"
                                name="password"
                                value={data.password}
                                onChange={onChangeHandler}
                                className="mt-1 p-2 w-full border rounded-md focus:border-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 transition-colors duration-300"
                            />
                        </div>
                        <div>
                            <button
                                type="button"
                                onClick={onClickSubmit}
                                className="w-full bg-green-600 text-white p-2 rounded-md hover:bg-green-700 transition-colors duration-300 mt-6">
                                Login
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;